import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  members: [],
  inviteUrl: null,
};

const slice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setMembers(state, action) {
      state.isLoading = false;
      state.members = action.payload;
    },
    setInviteUrl(state, action) {
      state.inviteUrl = action.payload;
    },
  },
});

export default slice.reducer;

const API = process.env.REACT_APP_HOST_API;

// ----------------------------------------------------------------------

export function fetchLeaderboard(deckId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${API}/decks/${deckId}/leaderboard`);
      dispatch(slice.actions.setMembers(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Decks/Leaderboard/InternalError'));
    }
  };
}

export function createInvite(deckId, { accessLevel, visibility } = {}) {
  return async (dispatch) => {
    const body = {};
    if (accessLevel) body.accessLevel = accessLevel;
    if (visibility) body.visibility = visibility;
    const response = await axios.post(`${API}/decks/${deckId}/invite`, body);
    dispatch(slice.actions.setInviteUrl(response.data.data.inviteUrl));
    return response.data.data; // { inviteCode, inviteUrl, inviteAccessLevel, visibility }
  };
}

export function joinDeck(inviteCode) {
  return async () => {
    const response = await axios.post(`${API}/decks/join/${inviteCode}`);
    return response.data.data; // cloned (or existing) deck
  };
}
